import { NavPage } from '@/components/page/Breadcrumbs';
import { PageContainer } from '@/components/page/PageContainer';
import { PageHeader } from '@/components/page/PageHeader';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { VerticalMenu } from '@/components/shared/menu/VerticalMenu';
import { gqlToTasks, useGetTask } from '@/services/tasks/useTasks';
import { FC } from 'react';
import { FiClipboard } from 'react-icons/fi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import strings from '../../admin.translations';
import AdminEditTaskDetailsCard from './AdminEditTaskDetailsCard';

export const AdminEditTaskPage: FC = () => {
  const { tabName, taskId } = useParams();

  if (!taskId) throw new Error('Missing task id');

  const { state } = useLocation();

  const navigate = useNavigate();

  const getTask = useGetTask();

  const task = state?.task ? gqlToTasks([state.task])[0] : getTask(taskId);

  if (!task) {
    throw new Error(`Task with ID ${taskId} not found`);
  }

  const breadcrumbs: NavPage[] = [
    {
      name: strings.page.admin,
      to: '/admin'
    },
    {
      name: strings.tasksSection.edit.task,
      to: '/admin/tasks'
    },
    {
      name: task.name,
      to: `/admin/tasks/${taskId}`
    }
  ];

  const sideMenuOptions = [
    {
      icon: <FiClipboard className="h-5 w-5" />,
      label: strings.tasksSection.edit.taskDetails,
      anchorId: 'edit-task',
      element: <AdminEditTaskDetailsCard task={task} />
    }
  ];

  const allElements = (
    <>
      <AdminEditTaskDetailsCard task={task} />
    </>
  );

  const selectedTab = tabName ?? sideMenuOptions[0].anchorId;
  const handleTabSelect = (anchorId: string) => {
    navigate(`/admin/tasks/${anchorId}`);
  };

  return (
    <PageContainer
      customHeader={<PageHeader pageTitle={strings.page.title} icon={<FiClipboard />} breadcrumbs={breadcrumbs} />}
    >
      <PageSizer className="flex gap-5 flex-col lg:flex-row" mode={SizerMode.PAGE}>
        <div className="hidden lg:flex gap-5 w-full">
          <VerticalMenu
            onTabSelect={handleTabSelect}
            sideMenuOptions={sideMenuOptions}
            isScroll={false}
            selectedTab={selectedTab}
          />
        </div>
        <div className="lg:hidden">
          <VerticalMenu
            onTabSelect={handleTabSelect}
            sideMenuOptions={sideMenuOptions}
            allElements={allElements}
            isScroll={true}
            selectedTab={selectedTab}
          />
        </div>
      </PageSizer>
    </PageContainer>
  );
};
